import React from "react";
import { useSelector } from "react-redux";
import { changeActiveChatData } from "../Helpers/Utility";
import { registerWindowEvent } from "../Helpers/windowEvent";
import { Initialization } from "../initial";
import { addDynamicIcons } from "../Redux/feature/dynamicIconDataSlice";
import { store } from "../Redux/store";
import SDK from "../SDK";
import { Layout } from "./Layout";

const ChatScreen = (props = {}) => {
  const {
    initial = {},
     initial: { width = "",  height = "" , enableDeviceSize = false } = {}
  } = props;
  const theme = useSelector((state) => state.themeData?.theme);
  React.useEffect(() => {
    async function webSocket() {
      const responseWebSocket = await SDK.getFriendsList();
      if (responseWebSocket.statusCode !== 200) {
        Initialization(initial);
      }
    }
    webSocket();
    if (initial.iconSet) {
      store.dispatch(addDynamicIcons(initial.iconSet));
    }
  }, [initial]);

  React.useEffect(() => {
    if (store.getState()?.activeChatData?.data?.length !== 0) {
      changeActiveChatData(initial?.customConversation);
    }
  }, [initial?.customConversation?.userId]);

  React.useMemo(() => {
    registerWindowEvent();
  }, []);
  /**
  // React.useLayoutEffect(() => {
  //     registerWindowEvent()
  //     console.log(
  //       "Occurs ONCE, but it still occurs AFTER the initial render."
  //     );
  //   }, []);
  */
  const IconProps = () => {
    return initial.iconSet;
  };

  return (
    <div id="mf-root-Parent" style={{ width: width ? width  : "100%",   height: height ? height : "100%" }}>
      <Layout
        darkTheme={theme === "dark"}
        IconProps={IconProps()}
        enableMobileView={initial.enableMobileView}
        logOut={initial.isLogout}
        customConversation={initial.customConversation}
        enableDeviceSize = {(width || height) ? false : enableDeviceSize}
        isCallEnabled = {initial.isCallEnabled}
      />
    </div>
  );
};

export default ChatScreen;
